/**
 * Part of toolstool project.
 *
 * @copyright  Copyright (C) 2022 __ORGANIZATION__.
 * @license    __LICENSE__
 */

// Cart buttons
const $cartButtons = $('[data-role=cart-button]');
const $cartButtonCounts = $cartButtons.find('.header-cart__count');

// Init
changeCartButtonsVisible();

function changeCartButtonsVisible() {
  $cartButtonCounts.each((i, ele) => {
    ele = $(ele);

    if (Number(ele.text().trim()) <= 0) {
      ele.hide();
    } else {
      ele.show();
    }
  });
}

u.directive('add-to-cart', {
  mounted(el) {
    $(el).on('click', async () => {
      const $quantity = $('[data-role=quantity]');
      let quantity = 1;

      if ($quantity.length) {
        quantity = parseInt($quantity.val()) || 1;
      }

      const id = el.dataset.id;

      const res = await u.$http.post('@cart_ajax/addToCart', {
        id,
        quantity
      });

      $cartButtonCounts.text(res.data.data.total);

      changeCartButtonsVisible();

      if (el.dataset.instant != null) {
        setTimeout(() => {
          location.href = $cartButtons.attr('href');
        }, 200);
      } else {
        swal({
          title: '成功加入購物車',
          buttons: [
            '繼續購物',
            '前往結帳'
          ]
        })
          .then((v) => {
            if (v) {
              location.href = $cartButtons.attr('href');
            }
          });
      }
    });
  }
});

// Product Quantity
u.directive('buy-quantity', {
  mounted(el) {
    const $el = $(el);
    const $minus = $el.find('[data-task=minus]');
    const $plus = $el.find('[data-task=plus]');
    const $quantity = $el.find('[data-role=quantity]');

    $minus.on('click', () => {
      modifyQuantity(-1);
    });

    $plus.on('click', () => {
      modifyQuantity(1);
    });

    $quantity.on('change', ensurePositive);

    function modifyQuantity(offset) {
      let qty = Number($quantity.val()) || 0;

      qty += offset;

      $quantity.val(qty);

      ensurePositive();

      $quantity[0].dispatchEvent(new CustomEvent('input'));
    }

    function ensurePositive() {
      let qty = parseInt($quantity.val()) || 0;

      if (qty < 1) {
        qty = 1;
      }

      $quantity.val(qty);
    }
  }
});
